<script>
import Input from 'dashboard/components-next/input/Input.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';

export default {
    components: {
        Input,
        TextArea
    },
    props: {
        preDefinedTime: {
            type: Date,
            default: null,
        },
    },
    emits: ['close', 'chooseSchedule'],

    data() {
        return {
            scheduleTimeString: '',
            message: '',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    },

    computed: {
        scheduleTime() {
            if (!this.scheduleTimeString) return null;
            // Criar Date no timezone local
            return new Date(this.scheduleTimeString);
        },
        scheduleTimeUTC() {
            if (!this.scheduleTime) return null;
            // Converter para UTC quando necessário
            return new Date(this.scheduleTime.toLocaleString('en-US', { timeZone: 'UTC' }));
        },
        isScheduleTimeValid() {
            if (!this.scheduleTime) return false;
            const now = new Date();
            // Comparar diretamente as datas locais
            return this.scheduleTime > now;
        },
        minDateTime() {
            const now = new Date();
            // Ajustar para o timezone local compensando o offset
            const offsetMs = now.getTimezoneOffset() * 60000;
            const localNow = new Date(now.getTime() - offsetMs);
            return localNow.toISOString().slice(0, 16);
        }
    },

    mounted() {
        if (this.preDefinedTime) {
            // Converter para string no timezone local
            const localDate = new Date(this.preDefinedTime.toLocaleString('en-US', { timeZone: this.timezone }));
            const year = localDate.getFullYear();
            const month = String(localDate.getMonth() + 1).padStart(2, '0');
            const day = String(localDate.getDate()).padStart(2, '0');
            const hours = String(localDate.getHours()).padStart(2, '0');
            const minutes = String(localDate.getMinutes()).padStart(2, '0');

            this.scheduleTimeString = `${year}-${month}-${day}T${hours}:${minutes}`;
        }
    },

    methods: {
        onClose() {
            this.$emit('close');
        },
        chooseSchedule() {
            if (!this.scheduleTime || !this.message.trim()) {
                return;
            }

            this.$emit('chooseSchedule', {
                scheduleTime: this.scheduleTime,
                message: this.message
            });
        },
    },
};
</script>

<template>
    <div class="flex flex-col">
        <woot-modal-header :header-title="$t('CONVERSATION.CUSTOM_SCHEDULE.TITLE')" />
        <form class="modal-content w-full pt-2 px-5 pb-6 flex flex-col gap-4" @submit.prevent="chooseSchedule">
            <Input v-model="scheduleTimeString" type="datetime-local" :min="minDateTime"
                :label="$t('CONVERSATION.CUSTOM_SCHEDULE.DATE_TIME_LABEL')" />
            <div class="mb-4">
                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                    {{ $t('CONVERSATION.CUSTOM_SCHEDULE.MESSAGE_LABEL') }}
                </label>
                <TextArea v-model="message" :placeholder="$t('CONVERSATION.CUSTOM_SCHEDULE.MESSAGE_PLACEHOLDER')"
                    rows="4"></textarea>
            </div>

            <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
                <woot-button variant="clear" @click.prevent="onClose">
                    {{ $t('CONVERSATION.CUSTOM_SCHEDULE.CANCEL') }}
                </woot-button>
                <woot-button :disabled="!scheduleTime || !isScheduleTimeValid || !message.trim()">
                    {{ $t('CONVERSATION.CUSTOM_SCHEDULE.SCHEDULE') }}
                </woot-button>
            </div>
        </form>
    </div>
</template>